<template>
  <div class="card text-center">
    <div
      class="card-header d-flex"
      :style="{
        backgroundColor: isPending ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }"
    >
      <h5 class="flex-grow-1">Work with Us</h5>
      <span v-if="isPending" class="float-right btn bg-secondary"
        ><i class="fa fa-lock text-white"></i
      ></span>
    </div>
    <div class="card-body">
      <div style="display: flex; flex-direction: row; align-items: center">
        <div
          v-if="!wwu_banner.image_url"
          style="
            width: 120px;
            height: 120px;
            object-fit: contain;
            border-radius: 10px;
            border: dashed 1px gray;
            display: flex;
            flex-direction: row;
            align-items: center;
          "
        >
          <span style="margin: auto; align-self: center"> + </span>
        </div>
        <img
          v-else
          :src="wwu_banner.image_url"
          style="
            width: 120px;
            height: 120px;
            object-fit: contain;
            border-radius: 10px;
            border: dashed 1px gray;
          "
        />
        <div class="fileUpload bg-none text-left align-middle">
          <div>
            <span class="media-text p-2"
              >Select from Media Library (Max dimension 1200 x 800 px)</span
            >
          </div>
          <button
            @click="openGalleryModal('editWwuBanner')"
            aria-hidden="true"
            class="mx-2 p-2 border w-auto"
          >
            Browse
          </button>
        </div>
      </div>
      <label class="form-label float-left speedee-bold mt-4"
        >Title<span class="text-danger">*</span></label
      >
      <input
        type="text"
        class="form-control mb-4 p-3"
        v-model="wwu_banner.title"
      />
      <label class="form-label float-left speedee-bold"
        >Description<span class="text-danger">*</span></label
      >
      <input
        type="text"
        class="form-control mb-4 p-3"
        v-model="wwu_banner.description"
      />
      <div class="float-right">
        <button @click="preview()" class="btn bg-light-dark text-dark m-2">
          Preview
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveWwuBanner(0)"
          class="btn bg-light-dark text-dark m-2"
        >
          Save Draft
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveWwuBanner(1)"
          class="btn btn-warning text-dark m-2"
        >
          Submit For Approval
        </button>
        <button
          v-if="isApprover && isPending"
          data-bs-toggle="modal"
          data-bs-target="#approveModal"
          class="btn btn-warning text-dark m-2 approveModal"
          @click="openWwuApproval('wwuBanner')"
        >
          Approval
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/services/RequestService";

export default {
  props: {
    wwu_banner: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    isApprover: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isPending: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
  },

  methods: {
    openWwuApproval(modalName) {
      document.getElementById("data_id").value = modalName;
    },

    async preview() {
      if (this.isPending || (this.isApprover && this.isApproved)) {
        window.open("/?preview=1");
      } else {
        let response = await postRequest(
          "/banners/home/work-with-us/" + this.wwu_banner.id,
          {
            title: this.wwu_banner.title,
            description: this.wwu_banner.description,
            gallery_id: this.wwu_banner.image_id ?? this.wwu_banner.image,
            approval: 0,
          },
          true
        );

        if (response.data.success) {
          window.open("/?preview=1");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            window.open("/?preview=1");
          });
        }
      }
    },

    openGalleryModal(section) {
      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    async saveWwuBanner(type) {
      console.log(this.wwu_banner);
      let response = await postRequest(
        "/banners/home/work-with-us/" + this.wwu_banner.id,
        {
          title: this.wwu_banner.title,
          description: this.wwu_banner.description,
          gallery_id: this.wwu_banner.image_id ?? this.wwu_banner.image,
          approval: type,
        },
        true
      );

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      } else {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        });
      }
    },
  },
};
</script>